export const progressColor = (value: number) => (value === 100 ? '#55D581' : '#397DFF');
